import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import Secret from "./pages/Secret";
import Privacy from "./pages/Privacy";
import FlightsCollectorPrivacy from "./pages/FlightsCollectorPrivacy";
import RootLayout from "./pages/RootLayout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "secret", element: <Secret /> },
      { path: "privacy", element: <Privacy /> },
      { path: "flights-collector/privacy", element: <FlightsCollectorPrivacy /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
